import {
  ARGONAUT,
  GENERATED_SHORTLIST,
  APPLICATION_FORM_DATA,
  PERSONAL_INFO,
  PLANNER_FORM_DATA,
  PLANNER_ID,
  SELECTED_TAB,
  SET_SHORTLISTED_PROGRAMS,
  SELECTED_APPLICATION_TAB,
  FETCHING_SHORTLIST,
} from "./types";

function setSelectedTab(tab) {
  return { type: SELECTED_TAB, payload: tab };
}

function setApplicationTab(tab) {
  return { type: SELECTED_APPLICATION_TAB, payload: tab };
}

function setPersonalInfo(info) {
  return { type: PERSONAL_INFO, payload: info };
}

function setGeneratedShortlist(info) {
  return { type: GENERATED_SHORTLIST, payload: info };
}

function setPlannerId(plannerId) {
  return { type: PLANNER_ID, payload: plannerId };
}

function setPlannerFormData(plannerFormData) {
  return { type: PLANNER_FORM_DATA, payload: plannerFormData };
}

function setArgonautLeadId(leadId) {
  return { type: ARGONAUT, payload: { leadId: leadId } };
}

function setApplicationFormData(info) {
  return { type: APPLICATION_FORM_DATA, payload: info };
}

function setShortlistedPrograms(programs) {
  return { type: SET_SHORTLISTED_PROGRAMS, payload: programs };
}

function fetchingShortlist(isFetching) {
  return { type: FETCHING_SHORTLIST, payload: isFetching };
}

const Actions = {
  setSelectedTab,
  setApplicationTab,
  setPersonalInfo,
  setGeneratedShortlist,
  setPlannerId,
  setPlannerFormData,
  setArgonautLeadId,
  setApplicationFormData,
  setShortlistedPrograms,
  fetchingShortlist,
};

export default Actions;
